import { InternalOrderEnums } from "src/app/enum/internal-order-enums";
import { MaintenanceOrderModel } from "../maintenance/maintenance-order.model";

export class InternalOrderModel {
  internalOrderId: number = 0;
  branchId: number = 0;
  consecutive: number = 0;
  alterNumber: number | null = null;
  dateInternalOrder: Date = new Date;
  internalOrderState: number = InternalOrderEnums.open;
  responsible: string = '';
  observation: string = '';
  maintenanceOrderId: number | null = null;
  maintenanceOrder: MaintenanceOrderModel | null = null;
  createDate: Date = new Date;
  userNameCreate: string = '';
  updateDate: Date | null = null;
  userNameUpdate: string = '';
}